const Normalize = require("./Normalize.js");
const Validate = require("./Validate.js");

module.exports = {
  
  now: async (email, password) => {
    
    try {
      Validate.email(email);
      Validate.password(password);
    } catch (error) {
      console.log("signin.now error:", error);
      throw error;
    }
    
    // normalize data
    email = Normalize.email(email);
    
    let cookie = localStorage.getItem("cookie");
    let csrf = localStorage.getItem("csrf");
    
    const res = await fetch("https://routes.hot0.workers.dev/signin", {
      method: "POST",
      credentials: "same-origin",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({
        cookie: cookie,
        csrf: csrf,
        email: email,
        pw: password,
      }),
    });
    
    if (res.status == 200) {
      const data = await res.text();
      
      // console.log("fetch.res.data");
      // console.log(data);
      
      if (data != "+") {
        alert("Looks like your account has been " + data);
      }
      
      
      
    } else {
      console.log("there was a server error");
      
      if (res.status == 400) {
        alert("Sorry, something went wrong.  We're sending you back in time...")
        // document.location = "/";
      }
      
      throw "not signed in";
    }
    
  },
  

}